<template>
  <div class="experience" v-if="model">
    <div class="header">
      <role v-for="(item, i) in model.roles" :key="i" :model="item"></role>
    </div>
    <div class="notes">
      <div class="note" v-for="(item, i) in model.data.notes" :key="i">{{ item }}</div>
    </div>
    <div class="body">
      <div class="logos">
        <div class="logo" v-for="(item, i) in model.roles" :key="i">
          <a v-if="item.data.employer.logo_file && item.data.employer.url"
             :href="item.data.employer.url"
             target="_blank">
            <img class="image" :src="`/images/biz-logos/light/${item.data.employer.logo_file}`" />
          </a>
          <img v-else-if="item.data.employer.logo_file"
               class="image"
               :src="`/images/biz-logos/light/${item.data.employer.logo_file}`" />
        </div>
      </div>
      <div>
        <ul class="highlights">
          <li v-for="(fragment, i) in highlightMarkup"
              :key="i"
              v-html="fragment"></li>
        </ul>
        <div class="details">
          <p v-for="(fragment, i) in detailMarkup"
             :key="i"
             class="md"
             v-html="fragment"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Role from './role';

import MarkdownMixin from '@/mixins/markdown';

export default {
    name       : "Experience",
    components : { Role },
    mixins     : [ MarkdownMixin ],
    props      : {
        model : {
            type : Object
        }
    },
    computed : {
        highlightMarkup() {
            return this.model.highlights().map(text => {
                return this.markdown.renderInline(text.trim());
            });
        },
        detailMarkup() {
            return this.model.details().map(text => {
                return this.markdown.renderInline(text.trim());
            });
        }
    }
};

</script>

<style scoped>

.experience {
    color:var(--core-white);
    background-image:-webkit-linear-gradient(to right, rgba(var(--main-gray-rgb), 0.5), rgba(var(--main-gray-rgb), 0.1));
    background-image:-moz-linear-gradient(to right, rgba(var(--main-gray-rgb), 0.5), rgba(var(--main-gray-rgb), 0.1));
    background-image:-ms-linear-gradient(to right, rgba(var(--main-gray-rgb), 0.5), rgba(var(--main-gray-rgb), 0.1));
    background-image:linear-gradient(to right, rgba(var(--main-gray-rgb), 0.5), rgba(var(--main-gray-rgb), 0.1));
    margin-top:50px;
    position:relative;
}

.experience:before {
    content:"";
    position:absolute;
    top:0px;
    left:0px;
    width:100%;
    height:100%;
    box-shadow:0px 0px 15px 5px var(--white-orange);
    opacity:0;
    transition:opacity 3000ms;
}

.experience:hover:before {
    opacity:1;
    transition:opacity 500ms;
}

.experience .header {
    background-color:rgba(var(--core-black-rgb), 0.5);
    padding:5px 10px;
}

.experience .notes {
    text-align:right;
    padding:5px 0px;
}

.experience .notes > .note {
    color:var(--soft-orange);
    font-style:italic;
    font-size:16px;
    padding:0px 10px;
}

.experience .body {
    display:flex;
    flex-wrap:nowrap;
    justify-content:flex-start;
    align-items:flex-start;
    padding:10px;
}

.experience .body .logos {
    flex-grow:0;
    display:flex;
    flex-direction:column;
    flex-wrap:nowrap;
    justify-content:flex-start;
    align-items:flex-start;
}

.experience .body .logos > .logo {
    padding:10px;
    margin-bottom:5px;
    position:relative;
    transform:scale(1);
    transition:transform 500ms;
}

.experience .body .logos > .logo + .logo {
    margin-top:30px;
}

.experience .body .logos > .logo:hover {
    transform:scale(1.1);
}

.experience .body .logos > .logo .image {
    width:120px;
}

.experience .body .highlights {
}

.experience .body .details {
}

.experience .body .details > p {
    font-size:16px;
    margin-left:1em;
}

.experience .body .highlights > li {
    font-size:16px;
}

</style>
